import { handle } from 'redux-pack';
import messages from './messages';

export const deletePhoto = (prevState, id) => prevState.photoList &&
  prevState.photoList.filter((photo) => (photo.id !== id));

export const selectMainPhoto = (prevState, id) => prevState.photoList &&
  prevState.photoList.map((photo) => ({
    ...photo,
    isPrincipal: photo.id === id,
  }));

// TODO Verify if the varaible 'hasNotInitialDataBeenRetrived' is actually doing something
export const deletePhotoPromise = (action) => ({
  failure: (prevState) => prevState,
  success: (prevState) => ({
    ...prevState,
    photoList: deletePhoto(prevState, action.meta.photoId),
    hasNotDataUploadedBeenRetrived: false,
    hasNotInitialDataBeenRetrived: false }),
});

export const handleDeletePhoto = (state, action) =>
  handle(state, action, deletePhotoPromise(action));

export const fetchPhotosPromise = (payload) => ({
  failure: (prevState) => ({
    ...prevState,
    hasStartedFetchPhotos: true,
    hasNotInitialDataBeenRetrived: false,
    hasNotDataUploadedBeenRetrived: false }),
  success: (prevState) => ({
    ...prevState,
    photoList: payload,
    hasNotDataUploadedBeenRetrived: false,
    hasNotInitialDataBeenRetrived: false,
    hasStartedFetchPhotos: true }),
});

export const handleFetchPhotos = (state, action) =>
  handle(state, action, fetchPhotosPromise(action.payload));

export const fetchRoomsSuggestionsPromise = (payload) => ({
  success: (prevState) => ({ ...prevState, roomsSuggestions: payload.suggestions }),
});

export const handleFetchRoomsSuggestions = (state, action) =>
  handle(state, action, fetchRoomsSuggestionsPromise(action.payload));

export const uploadPhotoPromise = (payload) => ({
  start: (prevState) => ({
    ...prevState,
    hasFinishedPhotoUpload: false,
    hasStartedPhotoUpload: true,
    photoListDropzoneVisibility: false,
  }),
  failure: (prevState) => ({
    ...prevState,
    hasSnackbar: true,
    snackbarState: 'error',
    snackbarMessage: messages.failureUploadPhotos.defaultMessage,
  }),
  success: (prevState) => ({
    ...prevState,
    photoList: [...prevState.photoList, payload],
    hasSnackbar: true,
    snackbarState: 'success',
    snackbarMessage: messages.successUploadPhotos.defaultMessage,
  }),
  finish: (prevState) => ({
    ...prevState,
    hasStartedPhotoUpload: false,
    hasFinishedPhotoUpload: true,
  }),
});

export const handleUploadFilePhotos = (state, action) =>
  handle(state, action, uploadPhotoPromise(action.payload));

export const updatePhotoListPromise = (extraProperties) => ({
  success: (prevState) => ({ ...prevState, photoList: extraProperties.photos }),
});

export const handleUpdateListPhotos = (prevState, action) =>
  ({ ...prevState, photoList: action.extraProperties.photos });

export const updatePhotosPromise = () => ({
  failure: (prevState) => ({
    ...prevState,
    hasSnackbar: true,
    snackbarState: 'error',
    snackbarMessage: messages.failureUpdatePhotospheres.defaultMessage,
  }),
  success: (prevState) => ({
    ...prevState,
    hasSnackbar: true,
    snackbarState: 'success',
    snackbarMessage: messages.successUpdatePhotospheres.defaultMessage,
  }),
});

export const handleUpdatePhotos = (state, action) => handle(state, action, updatePhotosPromise());

export const updateDescription = (prevState, extraProperties) => {
  // TODO: Check if its really necessary to copy this array
  const photos = [...prevState.photoList];
  const foundIndex = photos.findIndex((photo) => photo.id === extraProperties.id);
  photos[foundIndex].description = extraProperties.description;
  return photos;
};

export const handleUpdateDescriptionOnPhotoList = (prevState, action) => {
  updateDescription(prevState, action.extraProperties);
  return prevState;
};

export const handleUploadStart = (prevState) => ({
  ...prevState,
  hasNotDataUploadedBeenRetrived: true,
  hasFinishedPhotoUpload: false,
  hasStartedPhotoUpload: true,
});

export const changeDropZoneVisibility = (prevState, action) =>
  ({ ...prevState, photoListDropzoneVisibility: action.extraProperties.visibility });

export const handleChangeDropZoneVisibility = (state, action) =>
  changeDropZoneVisibility(state, action);

export const updateHasSnackbar = (prevState, extraProperties) =>
  ({ ...prevState, hasSnackbar: extraProperties.state });

export const handleUpdateHasSnackbar = (state, action) =>
  updateHasSnackbar(state, action.extraProperties);

export const handleAddPhotosToUpload = (prevState, action) => {
  // TODO: remove this ignore below
  // eslint-disable-next-line no-param-reassign
  prevState.photosToUpload = action.extraProperties.photosToUpload;
  return prevState;
};

export const updateMainPhotoPromise = (action) => ({
  failure: (prevState) => prevState,
  success: (prevState) => ({
    ...prevState,
    photoList: selectMainPhoto(prevState, action.meta.id),
  }),
});

export const handleUpdateMainPhoto = (state, action) =>
  handle(state, action, updateMainPhotoPromise(action));

export const rotatePhotoClockwisePromise = () => ({
  failure: (prevState) => prevState,
  success: (prevState) => prevState,
});

export const handleRotatePhotoClockwise = (state, action) =>
  handle(state, action, rotatePhotoClockwisePromise());
